export const AI_MODEL_TIERS = [
  {
    id: 'standard',
    labelKey: 'ai.tiers.standard.label',
    descriptionKey: 'ai.tiers.standard.description',
    multiplier: 1,
  },
  {
    id: 'extra-hard-thinking',
    labelKey: 'ai.tiers.extraHardThinking.label',
    descriptionKey: 'ai.tiers.extraHardThinking.description',
    multiplier: 2,
  },
];

export const DEFAULT_MODEL_TIER = 'standard';
